export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageUtil.worker.e9d9ac65.worker.js");
}
